<template>
  <div class="filter-containter">
    <img
      @click="$emit('closeDialog')"
      class="close-btn"
      src="../../assets/icons/close.png"
      alt="Close"
    >
    <v-container>
      <v-flex text-xs-center>
        <h1 class="header-text">
          <span>Filtriranje korisnika
            <div class="header-text-line"></div>
          </span>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-select
          v-model="filterObject.SelectedInstrument"
          :items="instruments"
          item-text="Name"
          item-value="InstrumentId"
          label="Instrument"
        ></v-select>
      </v-flex>

      <v-flex xs12>
        <v-select
          v-model="filterObject.SelectedRole"
          :items="roles"
          item-text="Name"
          item-value="RoleId"
          label="Korisnička uloga"
        ></v-select>
      </v-flex>

      <v-flex xs12>
        <v-checkbox label="Aktivan" v-model="filterObject.IsActive"></v-checkbox>
      </v-flex>

      <v-flex xs12 class="text-right">
        <v-btn class="main-btn" @click="filterUsers" >Filter</v-btn>
      </v-flex>
    </v-container>
  </div>
</template>
<script>
export default {
  props: ["filterObject"],
  data() {
    return {
      instruments: [],
      roles: []
    };
  },
  methods: {
    getInstruments() {
      this.$store.state.services.instrumentService.getAll().then(response => {
        this.instruments = response.data;

        //Sets first item in dropdown to empty
        this.instruments.unshift({
          InstrumentId: 0,
          Name: ""
        });
      });
    },
    getUserRoles() {
      this.$store.state.services.roleService.getAll().then(response => {
        this.roles = response.data;
        this.roles.unshift({
          RoleId: 0,
          Name: ""
        });
      });
    },
    filterUsers() {
      this.$emit("filter");
    }
  },
  created() {
    this.getInstruments();
    this.getUserRoles();
  }
};
</script>
<style scoped>
.filter-container {
  padding: 10px 20px;
  background-color: white;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 35px;
  cursor: pointer;
}
.header-text{
  margin-bottom: 15px;
}
</style>
